export default function Employment({employeeStatusList, warnings}) {
    return (
        <div>
            <h4
                id="sub_head"
                style={{
                    fontFamily: 'A Love of Thunder', color: '#007935', marginBottom: '10px'
                }}
            >
                Employee Status
            </h4>

            {
                employeeStatusList.map((status, index) => (<table
                        key={index}
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            border: '1px solid #ccc',
                        }}
                    >
                        <tbody>
                        <tr>
                            <td style={{padding: '8px 12px', fontWeight: 'bold'}}>Email:
                            </td>
                            <td style={{padding: '8px 12px', textAlign: 'right'}}>
                                {status?.email}
                            </td>
                        </tr>
                        <tr>
                            <td style={{padding: '8px 12px', fontWeight: 'bold'}}>Phone Number:
                            </td>
                            <td style={{padding: '8px 12px', textAlign: 'right'}}>
                                {status?.phone}
                            </td>
                        </tr>
                        <tr>
                            <td style={{padding: '8px 12px', fontWeight: 'bold'}}>Loyalty Id:
                            </td>
                            <td style={{padding: '8px 12px', textAlign: 'right'}}>
                                {status?.loyaltyId}
                            </td>
                        </tr>
                        <tr>
                            <td style={{padding: '8px 12px', fontWeight: 'bold'}}>Discount
                                Status:
                            </td>
                            <td style={{padding: '8px 12px', textAlign: 'right'}}>
                                {status?.discountStatus}
                            </td>
                        </tr>
                        <tr>
                            <td style={{padding: '8px 12px', fontWeight: 'bold'}}>Employee
                                Status:
                            </td>
                            <td style={{padding: '8px 12px', textAlign: 'right'}}>
                                {status?.employeeLinkedStatus}
                            </td>
                        </tr>

                        </tbody>
                    </table>

                ))
            }
            {
                warnings.length > 0 && (<div className="warning-box">
                    {warnings.map((msg, i) => (<div key={i} className="warning-text">
                        {msg}
                    </div>))}
                </div>)
            }
        </div>);
}